import { createContext, useContext, useEffect, useState } from "react";
import { api, apiError } from "./api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setLoading(false));
  }, []);

  const handle = async (path, payload) => {
    try {
      const { data } = await api.post(path, payload);
      localStorage.setItem("token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: apiError(e.response?.data?.detail) || e.message };
    }
  };

  const login = (email, password) => handle("/auth/login", { email, password });
  const register = (name, email, password) => handle("/auth/register", { name, email, password });
  const logout = () => { localStorage.removeItem("token"); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isOrganizer: user?.role === "organizer" || user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}
